import { useEffect } from "react";

const BaseModal = ({ open, onClose, title, children, width = 700 }) => {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.45)",
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
        padding: "16px",
      }}
      onClick={onClose}
    >
      <div
        style={{ width: "100%", maxWidth: width }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            background: "rgba(28, 41, 52, 0.6)",
            backdropFilter: "blur(5px) saturate(10%)",
            WebkitBackdropFilter: "blur(5px) saturate(120%)",
            border: "1px solid #008cff",
            borderRadius: 16,
            // boxShadow: "0 0 20px #008cff, 0 0 40px #008cff, 0 10px 30px rgba(0,0,0,0.35)",
            // animation: "shine 2s ease-in-out infinite alternate",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            // maxHeight: "your-value"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 16px",
              borderBottom: "1px solid rgba(42, 64, 82, 0.6)",
              background: "rgba(255,255,255,0.02)",
            }}
          >
            <h2 style={{ margin: 0, color: "#E7EDF2", fontSize: 18 }}>
              {title}
            </h2>
            <button
              type="button"
              aria-label="Close"
              onClick={onClose}
              style={{
                appearance: "none",
                outline: "none",
                border: "1px solid #008cff",
                color: "#FF4D4F",
                background: "transparent",
                width: 28,
                height: 28,
                lineHeight: "24px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#FF4D4F";
                e.currentTarget.style.color = "#FFFFFF";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "#FF4D4F";
              }}
            >
              ×
            </button>
          </div>

          <div style={{ padding: 16, overflowY: "auto", flex: 1 }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseModal;
